/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { isScriptElement } from '../types'

const LOCKED_VERSION_TAG_REGEX = /\/o11y-gdi-rum\/v\d+\.\d+\.\d+-[0-9a-f]{40}\//i

export const isAgentLoadedViaLatestTag = () => {
	let isLatestTagUsed = false
	try {
		if (document.currentScript && isScriptElement(document.currentScript)) {
			const src = document.currentScript.src
			// Check for "latest" version in CDN URL
			isLatestTagUsed = /\/o11y-gdi-rum\/latest\//i.test(src)
		}
	} catch {
		// ignore
	}

	return isLatestTagUsed
}

export const isAgentLoadedViaLockedVersionTag = () => {
	let isLockedVersionTagUsed = false
	try {
		if (document.currentScript && isScriptElement(document.currentScript)) {
			const src = document.currentScript.src
			isLockedVersionTagUsed = LOCKED_VERSION_TAG_REGEX.test(src)
		}
	} catch {
		// ignore
	}

	return isLockedVersionTagUsed
}

export const isAgentLoadedViaNextTag = () => {
	let isNextTagUsed = false
	try {
		if (document.currentScript && isScriptElement(document.currentScript)) {
			const src = document.currentScript.src
			// Check for "next" version in CDN URL (pre-release builds from main branch)
			isNextTagUsed = /\/o11y-gdi-rum\/next\//i.test(src)
		}
	} catch {
		// ignore
	}

	return isNextTagUsed
}
